import PageComponent from '../base/PageComponent';
import 'slick-carousel';

export default class Carousel extends PageComponent
{
    init() {
        this.setupCarousel();
    }

    setupCarousel() {
        if (this.getSlides() > 1) {
            this.childElements('.hero-item-container').slick({
                slide: '.hero-item',
                autoplay: true,
                autoplaySpeed: 5000,
                fade: true,
                speed: 1000,
                adaptiveHeight: false,
                dots: true,
                appendDots: $('.slider'),
                dotsClass: 'slick-dots slick-dots--light',
                customPaging: function (slider, i) {
                    var thumb = $(slider.$slides[i]).data('thumb');
                    return '<span></span>';
                },
                slidesToShow: 1,
                infinite: false,
                arrows: false,
                responsive: [
                    {
                        breakpoint: 1090,
                        settings: {
                            arrows: false
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            arrows: false,
                            dotsClass: 'slick-dots slick-dots--light'
                        }
                    }
                ]
            });
        }

        //this.addEvent('.next', 'click', e => this.onCarouselNext(e));
    }

    getSlides(){
        return this.childElements('.hero-item').length;
    }
}


// WEBPACK FOOTER //
// ./javascript/components/Carousel.js